module.exports = __webpack_public_path__ + "img/back.e1759e08.png";